import type { LumpsumAllocationCategory, LumpsumAllocationBuyRecommendation } from '../../../../api/allocation.types'
import {
  PlanCategoryBucketKey,
  PLAN_CATEGORY_BUCKET_TITLES,
  PlansPlanMode,
  type PlansActionFilter
} from '../../../../api/types'
import { usePlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../lumpsum-ui-components/BucketAccordion'
import { AllocationBuyFundCard } from '../cards/AllocationBuyFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansLumpsumListEventIds, PlansScreen } from '../../../../../analytics/plansEvents'

type AllocationBuyBucketAccordionProps = {
  category: LumpsumAllocationCategory
  categoryId: string
  actionFilter: PlansActionFilter
  isBorderTop?: boolean
}

export function AllocationBuyBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: AllocationBuyBucketAccordionProps) {
  const buyRecommendations = getCategoryBucketItems<LumpsumAllocationBuyRecommendation>(category?.buyRecommendations)
  const { bucketCompositeKey, isExpanded, toggle } = usePlanCategoryBucket({
    planMode: PlansPlanMode.ALLOCATION,
    actionFilter,
    categoryId,
    bucketKey: PlanCategoryBucketKey.buyRecommendations
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.buyRecommendations]}
      count={buyRecommendations.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.LumpsumAllocation,
            eventId: PlansLumpsumListEventIds.BucketAccordion,
            buttonLabel: PLAN_CATEGORY_BUCKET_TITLES[PlanCategoryBucketKey.buyRecommendations]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {buyRecommendations.map((recommendation, recommendationIndex) => (
        <AllocationBuyFundCard
          key={`${recommendation?.isin ?? 'fund'}-${recommendationIndex}`}
          recommendation={recommendation}
          categoryName={category?.categoryName ?? ''}
          showBottomDivider={recommendationIndex < buyRecommendations.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
